

import {originationValidatePhoneM}          from '../helpers/queries';
import {saveDataContact}                    from '../helpers/mutations_2';
import {NUM_VIEW_ANDROID, BASE_URL_SERVER}  from '../constants';

export const saveModelContact = async (uiidState, viewParam, params, url_server, isEditingView, inftProspect, isVerification, setCodeOTP, errors, setErrors, setProcessOnboarding, closeModal) => {

        originationValidatePhoneM(
            String(inftProspect.cellphone).trim(), 
            String(inftProspect.phonehome).trim(),
            uiidState
        ).then(function (responsePhone) {
    
            if(responsePhone == "error_service"){
                closeModal();
                errors['originPhone'] = 'serverError';
            }else{
                
                if(responsePhone.phoneCell.code == null){
                    closeModal();
                    errors['originPhone'] = 'serverError';
                }else if(responsePhone.phoneCell.message == "NOT FOUND"){
                    
                    if(responsePhone.phoneCell.code == null){
                        closeModal();
                        errors['originPhone'] = 'serverError';
                    }else if(responsePhone.phoneHome.message == "NOT FOUND"){
                        functionSaveContact(uiidState, viewParam, params, url_server, inftProspect, isVerification, errors, setErrors, setProcessOnboarding, closeModal);
                    }else if(responsePhone.phoneHome.message == "NOT ACEPTABLE"){
                        closeModal();
                        errors['originPhone'] = 'cellHPhoneNAceptable';

                    }else{
                        closeModal();
                        errors['originPhone'] = 'serverError';
                    }

                }else if(responsePhone.phoneCell.message == "NOT ACEPTABLE"){
                    closeModal();
                    errors['originPhone'] = 'cellPhoneNAceptable';

                    setCodeOTP((prev) => {
                        return { ...prev, ['validateCode']: false }
                    });
                }else{
                    closeModal();
                    errors['originPhone'] = 'serverError';
                }
    
            }
    
            setErrors((prevState) => {
                return { ...prevState, ...errors }
            });
    
        });


}

const functionSaveContact = async (uiidState, viewParam, params, url_server, inftProspect, isVerification, errors, setErrors, setProcessOnboarding, closeModal) => {

    saveDataContact(
                    String(uiidState), 
                    isVerification,
                    String(inftProspect.phonehome).trim(), 
                    String(inftProspect.cellphone).trim(), 
                    String(inftProspect.email).trim() 
    ).then(function (respSave) {

        if(respSave.message === "error"){
            closeModal();
            errors['serviceServer'] = 'serverError';
        }else if(respSave.message === "No Data"){
            closeModal();
            errors['serviceServer'] = 'noSave';
        }else if(respSave.message === "Success"){
            
            if(String(params[0]) === "MovilAndroid"){
                try{
                    window.Android.guardaCache(NUM_VIEW_ANDROID["contact"],BASE_URL_SERVER+url_server[0]+"&contact");
                }catch(error){}
            }

            closeModal();
            setErrors({});
            setProcessOnboarding(viewParam);

        }else{
            closeModal();
            errors['serviceServer'] = 'serverError';
        }

        setErrors((prevState) => {
            return { ...prevState, ...errors }
        });

    });

}